module.exports = __webpack_public_path__ + "static/media/Extruded tooth13.b807b499.png";